export default function ProgramIncludes() {
  const steps = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Аудит текущих показателей, прослушивание звонков, анализ переписок' },
    { icon: 'ri-mic-line', title: 'Прослушивание звонков', desc: 'Разбор реальных разговоров с клиентами компании' },
    { icon: 'ri-chat-1-line', title: 'Анализ переписок', desc: 'Изучение переписок в мессенджерах и почте на предмет потерянных сделок' },
    { icon: 'ri-settings-3-line', title: 'Адаптация программы', desc: 'Программа строится под ваш продукт, рынок и типичные возражения' },
    { icon: 'ri-presentation-line', title: 'Практический тренинг', desc: '80% времени — отработка на реальных кейсах и ролевых переговорах' },
    { icon: 'ri-user-voice-line', title: 'Ролевые переговоры', desc: 'Поединки с разбором: что сработало, что потеряли, как усилить' },
    { icon: 'ri-book-open-line', title: 'Домашние задания', desc: 'Практика между модулями с обратной связью от тренера' },
    { icon: 'ri-hand-heart-line', title: 'Сопровождение', desc: 'Поддержка внедрения: разборы, корректировка, чат с тренером' },
    { icon: 'ri-file-list-3-line', title: 'Разбор реальных переговоров', desc: 'Анализ новых звонков после обучения и корректировка стратегии' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что входит в корпоративный тренинг
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Полный цикл от диагностики до закрепления результатов. Каждый этап направлен на измеримое улучшение показателей отдела продаж.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-teal-200 hidden sm:block"></div>
            <div className="space-y-6">
              {steps.map((step, i) => (
                <div key={i} className="flex items-start gap-4 sm:gap-6">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 z-10">
                    <i className={`${step.icon} text-white text-lg`}></i>
                  </div>
                  <div className="bg-white rounded-xl p-5 flex-1 shadow-sm border border-gray-100">
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{step.title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}